module.exports = __webpack_public_path__ + "img/nfe.a69f9b2c.webp";